// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*=============================================================
               Consultant List Table
===============================================================*/
.main_content.trans-anttable {
  background: #f2f2f2;
  min-height: 80vh;
  padding-top: 15px;
  background: #ffffff;
  text-align: center;
}
.trans-anttable h4 {
  font-size: 25px;
  text-align: center;
  position: relative;
  display: inline-block;
  margin-bottom: 30px;
  color: #071721;
}
.trans-anttable h4::after {
  height: 3px;
  width: 34px;
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  content: "";
  background: #071721;
  bottom: -5px;
  width: 40%;
}
.trans-anttable .ant-table table {
  background: #ffffff;
  border: 1px solid #ececec;
  border-radius: 5px;
}
.trans-anttable .ant-table-thead > tr > th {
  background: transparent;
  color: #3c3c3c;
  padding: 12px 12px;
}
.trans-anttable .ant-table-thead > tr > th .ant-table-column-title {
  font-size: 17px;
  
  font-weight: 500;
}

.trans-anttable .ant-table-tbody > tr > td {
  padding: 12px 12px;
}
.trans-anttable tr.ant-table-row {
  background: #f2f2f2;
}

.trans-anttable .ant-table-thead > tr > th.ant-table-column-sort,
.trans-anttable
  .ant-table-thead
  > tr
  > th.ant-table-column-has-actions.ant-table-column-has-sorters:hover {
  background: #e0e0e0;
  color: #071721;
}
.trans-anttable .ant-table-tbody .ant-table-row:nth-of-type(even) {
  background: #ffffff;
  color: #565656;
}
.trans-anttable .ant-pagination-prev .ant-pagination-item-link,
.trans-anttable .ant-pagination-next .ant-pagination-item-link {
  line-height: 2.2;
}
.trans-anttable .ant-pagination-item-active {
  border-color: #071721;
}

/* #questionConsultantModal .modal-body > div {
  border: 1px dashed #eaeaea;
  padding: 5px 5px;
}
#questionConsultantModal .modal-body label {
  font-size: 14px;
  color: #bfbfbf;
  margin-bottom: 0px;
}
#questionConsultantModal .modal-body span {
  display: block;
  font-size: 15px;
  
  font-weight: 500;
}
#questionConsultantModal button.close {
  color: #333;
  font-weight: 100;
  text-align: right;
  font-size: 18px;
  padding-right: 10px;
  padding-top: 5px;
  margin: 0px;
  padding-bottom: 0px;
}
#questionConsultantModal .modal-header {
  border: 0px;
  padding-bottom: 0px;
}
#questionConsultantModal .modal-header .modal-title {
  font-size: 18px;
  color: #5f5f5f;
} */
.trans-anttable .ant-table-tbody > tr > td:first-child {
  cursor: pointer;
}

.scorllInterested {
  max-height: 400px;
  overflow-x: hidden;
}
.trans-anttable .table-top-input-btn {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.trans-anttable
  .table-top-input-btn
  .ant-select-auto-complete.ant-select
  .ant-input {
  height: 36px;
  line-height: 30px;
}
label.s_label {
  font-size: 14px;
  color: #000000;
  padding-left: 3px;
  margin: 0;
  
  font-weight: 500;
}
#add-consultant-modal .ant-select-selection--multiple {
  border: 0px;
}

#add-consultant-modal.modal.new_modal_pop #consultant-city.form-control {
  min-height: 42px;
  height: auto;
}
`, "",{"version":3,"sources":["webpack://./app/pages/Supplier/ClientProfileList/clientProfileList.css"],"names":[],"mappings":"AAAA;;gEAEgE;AAChE;EACE,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,kBAAkB;EAClB,kBAAkB;EAClB,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,WAAW;EACX,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,2BAA2B;EAC3B,WAAW;EACX,mBAAmB;EACnB,YAAY;EACZ,UAAU;AACZ;AACA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;AACpB;AACA;EACE,uBAAuB;EACvB,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,eAAe;;EAEf,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;AACA;EACE,mBAAmB;AACrB;;AAEA;;;;;EAKE,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;AACA;;EAEE,gBAAgB;AAClB;AACA;EACE,qBAAqB;AACvB;;AAEA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;GAgCG;AACH;EACE,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;AACA;;;;EAIE,YAAY;EACZ,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,SAAS;;EAET,gBAAgB;AAClB;AACA;EACE,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,YAAY;AACd","sourcesContent":["/*=============================================================\n               Consultant List Table\n===============================================================*/\n.main_content.trans-anttable {\n  background: #f2f2f2;\n  min-height: 80vh;\n  padding-top: 15px;\n  background: #ffffff;\n  text-align: center;\n}\n.trans-anttable h4 {\n  font-size: 25px;\n  text-align: center;\n  position: relative;\n  display: inline-block;\n  margin-bottom: 30px;\n  color: #071721;\n}\n.trans-anttable h4::after {\n  height: 3px;\n  width: 34px;\n  position: absolute;\n  left: 50%;\n  transform: translateX(-50%);\n  content: \"\";\n  background: #071721;\n  bottom: -5px;\n  width: 40%;\n}\n.trans-anttable .ant-table table {\n  background: #ffffff;\n  border: 1px solid #ececec;\n  border-radius: 5px;\n}\n.trans-anttable .ant-table-thead > tr > th {\n  background: transparent;\n  color: #3c3c3c;\n  padding: 12px 12px;\n}\n.trans-anttable .ant-table-thead > tr > th .ant-table-column-title {\n  font-size: 17px;\n  \n  font-weight: 500;\n}\n\n.trans-anttable .ant-table-tbody > tr > td {\n  padding: 12px 12px;\n}\n.trans-anttable tr.ant-table-row {\n  background: #f2f2f2;\n}\n\n.trans-anttable .ant-table-thead > tr > th.ant-table-column-sort,\n.trans-anttable\n  .ant-table-thead\n  > tr\n  > th.ant-table-column-has-actions.ant-table-column-has-sorters:hover {\n  background: #e0e0e0;\n  color: #071721;\n}\n.trans-anttable .ant-table-tbody .ant-table-row:nth-of-type(even) {\n  background: #ffffff;\n  color: #565656;\n}\n.trans-anttable .ant-pagination-prev .ant-pagination-item-link,\n.trans-anttable .ant-pagination-next .ant-pagination-item-link {\n  line-height: 2.2;\n}\n.trans-anttable .ant-pagination-item-active {\n  border-color: #071721;\n}\n\n/* #questionConsultantModal .modal-body > div {\n  border: 1px dashed #eaeaea;\n  padding: 5px 5px;\n}\n#questionConsultantModal .modal-body label {\n  font-size: 14px;\n  color: #bfbfbf;\n  margin-bottom: 0px;\n}\n#questionConsultantModal .modal-body span {\n  display: block;\n  font-size: 15px;\n  \n  font-weight: 500;\n}\n#questionConsultantModal button.close {\n  color: #333;\n  font-weight: 100;\n  text-align: right;\n  font-size: 18px;\n  padding-right: 10px;\n  padding-top: 5px;\n  margin: 0px;\n  padding-bottom: 0px;\n}\n#questionConsultantModal .modal-header {\n  border: 0px;\n  padding-bottom: 0px;\n}\n#questionConsultantModal .modal-header .modal-title {\n  font-size: 18px;\n  color: #5f5f5f;\n} */\n.trans-anttable .ant-table-tbody > tr > td:first-child {\n  cursor: pointer;\n}\n\n.scorllInterested {\n  max-height: 400px;\n  overflow-x: hidden;\n}\n.trans-anttable .table-top-input-btn {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n.trans-anttable\n  .table-top-input-btn\n  .ant-select-auto-complete.ant-select\n  .ant-input {\n  height: 36px;\n  line-height: 30px;\n}\nlabel.s_label {\n  font-size: 14px;\n  color: #000000;\n  padding-left: 3px;\n  margin: 0;\n  \n  font-weight: 500;\n}\n#add-consultant-modal .ant-select-selection--multiple {\n  border: 0px;\n}\n\n#add-consultant-modal.modal.new_modal_pop #consultant-city.form-control {\n  min-height: 42px;\n  height: auto;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
